<template>
  <div style="display: inline-block;"
       @click="click">
    <slot></slot>
  </div>
</template>

<script>
import options from '@views/question-editor/utils/options'

export default {
  components: {},
  inject: {
    SjQuestionOption: {
      default: {},
    },
    SjQuestionOptionItem: {
      default: {},
    },
  },
  inheritAttrs: false,
  props: {
    value: Array,
    action: String,
    options: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {}
  },
  computed: {
    index () {
      return this.SjQuestionOptionItem.index
    },
  },
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    click () {
      this[this.action](this.options)
    },
    /**
     * 上移题目
     */
    up () {
      options.up(this.value, this.index)
    },
    /**
     * 下移题目
     */
    down () {
      options.down(this.value, this.index)
    },
    /**
     * 复制题目
     * @param toIndex
     */
    copy (toIndex) {
      // 复制到指定位置
      !Number.isInteger(toIndex) && (toIndex = this.value.length)
      let option = options.copy(this.value, this.index, toIndex)
      options.addDependency(this.value, option)
    },
    /**
     * 移除题目
     */
    remove () {
      options.removeDependency(this.value, this.value[this.index].id)
      options.remove(this.value, this.index)
    },
    /**
     * 添加题目
     *
     * @param type
     * @param toIndex
     */
    add ({type, toIndex}) {
      this.SjQuestionOption.add(this.value, type, toIndex)
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/packages/sj-question-option/src/SjQuestionOptionButton.vue